<template>
  <div class="home">
    <MonacoEditor :value.sync="value" :originalValue="originalValue" ref="MonacoEditor" @parseRes="parseRes" />
    <button @click="handleClick">验证</button>
  </div>
</template>

<script>
import MonacoEditor from '@/components/MonacoEditor'
export default {
  components: {
    MonacoEditor
  },
  data() {
    return {
      value: `pragma solidity ^0.4.22;
          contract Purchase {
              uint public value;
              address public seller;
              address public buyer;
              enum State { Created, Locked, Inactive }
              State public state;
          }`,
      originalValue: `pragma solidity ^0.4.22;
          contract Purchase {
              uint public value;
              address public seller;
              address public buyer;
              enum State { Created, Locked, Inactive }
              State public state;
          }`
    }
  },
  methods: {
    handleClick() {
      this.$refs.MonacoEditor.handleParser()
    },
    // 代码验证结果
    parseRes(obj) {
      console.log(obj)
    }
  }
}
</script>

<style lang="scss"></style>
